import { takeLatest, delay } from 'redux-saga'
import { fork, put, call } from 'redux-saga/effects'
import createDocumentSaga from 'sagas/createDocumentSaga'
import { validateMultiple } from 'tv4'
import uuid from 'uuid'
import legacyProjectSchemaGenerator from 'schemas/legacy'
import migrator from 'schemas/migrator'
import projectSchema from 'schemas/v2'
import { changeProjectAction, addProjectAction, removeLegacyProjectAction } from 'actions/projectActions'
import { addMessageAction, clearMessageAction } from 'actions/messageActions'
import { MIGRATE_LEGACY_PROJECT } from 'actions/projectActionTypes'
import { Honeybadger } from 'configuredModules'
import updateCalculatorProject from 'helpers/updateCalculatorProject'

function * clearErrorMessage() {
  yield delay(4000)
  yield put(clearMessageAction('projectListError'))
}

function * notifyHoneybadger(legacyResult, v1Result) {
  yield put(addMessageAction('projectListError', 'There is a problem with opening your project. We have been notified and are working on the issue.'))
  yield fork(clearErrorMessage)
  Honeybadger.notify({
    message: 'Legacy migration failed',
    context: {
      legacyErrors: legacyResult.errors.map(({ message, params, dataPath }) => ({ message, params, dataPath })),
      v1Errors: v1Result.errors.map(({ message, params, dataPath }) => ({ message, params, dataPath }))
    }
  })
}

export function * migrateLegacyProject(action) {
  try {
    const legacyResult = validateMultiple(action.project.parameters, legacyProjectSchemaGenerator(action.project.parameters))
    const migratedProject = yield call(migrator, action.project)

    const v1Result = validateMultiple(migratedProject, projectSchema)

    if (!v1Result.valid) {
      yield call(notifyHoneybadger, legacyResult, v1Result)
      return
    }

    const _id = uuid.v4()
    yield call(createDocumentSaga, { ...migratedProject, type: 'project', _id })
    yield put(addProjectAction({ ...migratedProject, _id }))
    yield put(changeProjectAction(_id))
    yield fork(updateCalculatorProject, action.project.uniqueKey, { display_in_v3: false })
    yield put(removeLegacyProjectAction(action.project.uniqueKey))
  } catch (err) {
    yield put(addMessageAction('projectListError', 'There is a problem with opening your project. We have been notified and are working on the issue.'))
    yield fork(clearErrorMessage)
    Honeybadger.notify({ message: err.message })
  }
}

export function * watchMigrateLegacyProject() {
  yield * takeLatest(MIGRATE_LEGACY_PROJECT, migrateLegacyProject)
}



// WEBPACK FOOTER //
// ./src/sagas/migrateLegacyProjectSaga.js